import ObjectFitClass from "../utils/_object-fit";

var $ = jQuery;

export default class ArticleArchive {

    ready() {

		this.WRAPPER = document.querySelector('.mtt-articles-widget--all');
		if (!this.WRAPPER) return;

		this.ARTICLES_WRAP = document.getElementById('mtt-articles-widget-posts');
		this.PAGINATION_WRAP = document.getElementById('mtt-articles-widget-pagination');
		this.CATEGORIES = this.WRAPPER.querySelectorAll('.mtt-articles-widget__filter-toggle');
		this.LOADER = this.WRAPPER.querySelector('.mtt-articles-widget__loader');
		this.SCROLL_TO_ID = '#mtt-articles-widget-scrollto';

		this.url = this.WRAPPER.getAttribute('data-main-url');
		this.data = {
			'action': 'filter_articles',
			'category': 'null',
			'page_number': 1
		};

		this.categoriesHandler();
		this.paginationToggleHandler();
	}

	categoriesHandler() {
		if (this.CATEGORIES.length === 0) return;

		for (let i = 0; i < this.CATEGORIES.length; i++) {
			const TOGGLE = this.CATEGORIES[i];

			TOGGLE.addEventListener('click', () => {

				// update company size
				this.data.category = TOGGLE.getAttribute('data-category');

				// update page number
				this.data.page_number = 1;

				// set active class
				for (let i = 0; i < this.CATEGORIES.length; i++) {
					this.CATEGORIES[i].classList.remove('mtt-articles-widget__filter-toggle--active');
				}
				TOGGLE.classList.add('mtt-articles-widget__filter-toggle--active');

				// ajax call
				this.filterArticles();

				// set url
				this.setUrl( this.url );

			});
		}
	}

	paginationToggleHandler() {
		const PAGINATION_TOGGLES = document.querySelectorAll('#mtt-articles-widget-pagination .mtt-pagination__toggle');
		if (PAGINATION_TOGGLES.length === 0) {
			return;
		}

		for (let i = 0; i < PAGINATION_TOGGLES.length; i++) {
			const TOGGLE = PAGINATION_TOGGLES[i];

			TOGGLE.addEventListener('click', (e) => {
				e.preventDefault();

				// update page number
				this.data.page_number = parseInt( TOGGLE.getAttribute('data-page') );

				// ajax call
				this.filterArticles();

				// set url
				this.setUrl( this.data.page_number === 1 ? this.url : TOGGLE.getAttribute('href') );

				// scroll top
				this.scrollToTop();

			});
		}
	}

	filterArticles() {
		
		this.showLoader();

		$.post(main_theme_objects.ajax_url, this.data, (response) => {
            if (response != 0) {
				
				if (this.ARTICLES_WRAP) this.ARTICLES_WRAP.innerHTML = response.markup;
				
				if (this.PAGINATION_WRAP) {
					this.PAGINATION_WRAP.innerHTML = response.pagination;
					this.paginationToggleHandler(); // reinit pagination
				}
				
				new ObjectFitClass(); // re-run objectfit

				this.hideLoader();
            }
		});
	}

	setUrl(url) {

		let categories = this.data.category.split(',');

        // Set category parameter
        let category_parameter = this.data.category !== 'null' && categories.length === 1 ? 
            `?cat=${this.data.category}` : 
            '';

        // Push to history
		window.history.pushState({
			'html': document.body.innerHTML,
			'pageTitle': document.title
		}, '', url + category_parameter);
	}

	showLoader() {
		if (this.LOADER) this.LOADER.classList.add('loader--show');
	}

	hideLoader() {
		if (this.LOADER) this.LOADER.classList.remove('loader--show');
	}

	scrollToTop() {

		const HEADER = document.getElementById('main_header');
		const ADMIN_BAR = document.getElementById('wpadminbar');

		let offset = HEADER ? HEADER.getBoundingClientRect().height : 100;
		offset += ADMIN_BAR ? ADMIN_BAR.getBoundingClientRect().height : 0;

		$('html, body').animate({ 
			scrollTop: $(this.SCROLL_TO_ID).offset().top - offset
		}, 800);
	}
}